export function operacaoRadPreFaturaBloqueioPlacaRelatorioInRequest(params = {}) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/OPERACAORADPREFATURABLOQUEIOPLACARELATORIO_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoRadPreFaturaBloqueioPlacaRelatorio(fatu_codigo) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/FIND_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/FAILED_REQUEST',
  };
}

export function deleteOperacaoRadPreFaturaBloqueioPlacaRelatorio(fatu_codigo, params) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/DELETE_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoRadPreFaturaBloqueioPlacaRelatorio(operacaoradprefaturabloqueioplacarelatorio, params) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/UPDATE_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    payload: { operacaoradprefaturabloqueioplacarelatorio, params },
  };
}

export function storeOperacaoRadPreFaturaBloqueioPlacaRelatorio(operacaoradprefaturabloqueioplacarelatorio, params) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/STORE_OPERACAORADPREFATURABLOQUEIOPLACARELATORIO',
    payload: { operacaoradprefaturabloqueioplacarelatorio, params },
  };
}

export function successInRequest(
  operacaoradprefaturabloqueioplacarelatorio,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/SUCCESS_IN_REQUEST',
    payload: { operacaoradprefaturabloqueioplacarelatorio, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoradprefaturabloqueioplacarelatorio) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/SUCCESS_REQUEST',
    payload: { operacaoradprefaturabloqueioplacarelatorio },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoradprefaturabloqueioplacarelatorio/RECORD_FILTERING',
    payload: { params },
  };
}
